var _path, _path2, _path3, _g, _path4, _circle, _circle2, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuppy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m352 488h-16a88.1 88.1 0 0 1 -88-88v-16a8 8 0 0 1 16 0v16a72.081 72.081 0 0 0 72 72h16a72.081 72.081 0 0 0 72-72v-16a8 8 0 0 1 16 0v16a88.1 88.1 0 0 1 -88 88z",
    fill: "#4799cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m248 384h16v16h-16z",
    fill: "#3775a4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m432 24v55.34a239.952 239.952 0 0 1 -25.34 107.34l-9.39 18.79a48 48 0 0 1 -42.94 26.53h-2.33l-29.15 75.8a44 44 0 0 1 -41.07 28.2h-51.56a44 44 0 0 1 -41.07-28.2l-29.15-75.8h-2.33a48 48 0 0 1 -42.94-26.53l-9.39-18.8a239.879 239.879 0 0 1 -25.34-107.33v-55.34l93.66 73.59a47.994 47.994 0 0 1 18.34 37.74v.67l28.22-14.11a80.019 80.019 0 0 1 71.56 0l28.22 14.11v-.67a47.994 47.994 0 0 1 18.34-37.74z",
    fill: "#a45e14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#70400e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160 232v-80l-2.788-1.858a96.007 96.007 0 0 1 -32.612-36.942l-44.6-89.2v55.344a240.006 240.006 0 0 0 25.337 107.331l9.4 18.791a48 48 0 0 0 42.929 26.534z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 232v-80l2.788-1.858a96.007 96.007 0 0 0 32.612-36.942l44.6-89.2v55.344a240.006 240.006 0 0 1 -25.337 107.331l-9.4 18.791a48 48 0 0 1 -42.929 26.534z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 208,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 208,
    r: 12
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m351.888 176a7.961 7.961 0 0 1 4.55 1.345l24 16a8 8 0 0 1 3.562 6.655v64a128 128 0 0 1 -256 0v-64a8 8 0 0 1 3.562-6.656l24-16a7.962 7.962 0 0 1 4.515-1.344l-.077 17.615-16 10.666v59.719a112 112 0 0 0 224 0v-59.719l-16-10.666z",
    fill: "#4799cf"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 344,
    fill: "#cbcbcb",
    r: 40
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 344,
    fill: "#a8a8a8",
    r: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m287.99 335.56a43.963 43.963 0 0 1 -6.21.44h-11.78l-14-18.67-14 18.67h-11.78a43.963 43.963 0 0 1 -6.21-.44 7.945 7.945 0 0 1 1.59-4.36l22.4-29.87v-21.33a8 8 0 0 1 16 0v21.33l22.4 29.87a7.945 7.945 0 0 1 1.59 4.36z",
    fill: "#70400e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m279.8 276.1a36.945 36.945 0 0 1 -16.522 3.9h-14.557a36.945 36.945 0 0 1 -16.522-3.9 14.834 14.834 0 0 1 -8.2-13.267 14.833 14.833 0 0 1 14.834-14.833h34.334a14.833 14.833 0 0 1 14.833 14.833 14.834 14.834 0 0 1 -8.2 13.267z",
    fill: "#70400e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuppy);
export default __webpack_public_path__ + "static/media/puppy.49ad9275.svg";
export { ForwardRef as ReactComponent };